var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-contact-us" },
    [
      _c("div", { staticClass: "grid-container u-spacing--bottom" }, [
        _c(
          "div",
          {
            staticClass:
              "grid-x grid-margin-x o-columns__one o-columns__one--narrow"
          },
          [
            _c(
              "div",
              { staticClass: "cell" },
              [
                _vm.content.heading
                  ? _c(
                      _vm.content.headingType,
                      {
                        tag: "component",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.content.heading) +
                            "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      !_vm.activePanel
        ? _c("Select", {
            attrs: {
              id: "contactUsSelect",
              label: _vm.content.heading,
              placeholder: "Please select",
              options: _vm.selectOptions
            },
            on: { change: _vm.setActivePanel }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.panels, function(panel) {
        return [
          _vm.activePanel && _vm.activePanel.title === panel.title
            ? _c(
                "accordion-container",
                {
                  key: panel.index,
                  on: { selectionEdited: _vm.resetActivePanel }
                },
                [
                  _c(
                    "accordion-panel",
                    {
                      key: _vm.index,
                      attrs: {
                        editLabel: _vm.content.editPanelLabel,
                        editLabelMobile: _vm.content.editPanelLabelMobile,
                        title: panel.title,
                        "title-id": panel.id,
                        "is-active": true,
                        "is-expanded": _vm.isPanelExpanded(panel),
                        showEditLink: !_vm.showIconList(panel)
                      },
                      on: {
                        active: _vm.setActivePanel,
                        setCurrentPanel: _vm.resetActivePanel
                      }
                    },
                    [
                      _vm.showIconList(panel)
                        ? _c("icon-list", {
                            attrs: {
                              items: panel.children,
                              title: panel.title
                            },
                            on: {
                              click: _vm.setCurrentPanel,
                              setCurrentPanel: _vm.resetActivePanel
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRap(panel)
                        ? _c("report-problem", {
                            attrs: {
                              componentId: _vm.rapComponentId,
                              config: panel.rapConfig,
                              questions: _vm.rapQuestions,
                              content: _vm.rapContent,
                              journey: _vm.currentPanel,
                              user: _vm.user
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showContentTemplate(panel)
                        ? _c("content-template", {
                            attrs: { config: panel.config }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(panel.children, function(levelTwo) {
                    return [
                      _c(
                        "accordion-panel",
                        {
                          key: levelTwo.index,
                          attrs: {
                            editLabel: _vm.content.editPanelLabel,
                            editLabelMobile: _vm.content.editPanelLabelMobile,
                            title: levelTwo.title,
                            "is-active": _vm.isPanelActive(levelTwo),
                            "is-expanded": _vm.isPanelExpanded(levelTwo),
                            showEditLink: !_vm.showIconList(levelTwo)
                          },
                          on: {
                            setCurrentPanel: function($event) {
                              return _vm.setCurrentPanel(panel.title)
                            }
                          }
                        },
                        [
                          _vm.showIconList(levelTwo)
                            ? _c("icon-list", {
                                attrs: {
                                  items: levelTwo.children,
                                  title: levelTwo.title
                                },
                                on: {
                                  click: _vm.setCurrentPanel,
                                  setCurrentPanel: function($event) {
                                    return _vm.setCurrentPanel(panel.title)
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showRap(levelTwo)
                            ? _c("report-problem", {
                                attrs: {
                                  componentId: _vm.rapComponentId,
                                  config: levelTwo.rapConfig,
                                  questions: _vm.rapQuestions,
                                  content: _vm.rapContent,
                                  journey: _vm.currentPanel,
                                  user: _vm.user
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.showContentTemplate(levelTwo)
                            ? _c("content-template", {
                                attrs: { config: levelTwo.config }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(levelTwo.children, function(levelThree) {
                        return _c(
                          "accordion-panel",
                          {
                            key: levelThree.index,
                            attrs: {
                              editLabel: _vm.content.editPanelLabel,
                              editLabelMobile: _vm.content.editPanelLabelMobile,
                              title: levelThree.title,
                              "is-active": _vm.isPanelActive(levelThree),
                              "is-expanded": _vm.isPanelExpanded(levelThree),
                              showEditLink: !_vm.showIconList(levelThree)
                            },
                            on: {
                              setCurrentPanel: function($event) {
                                return _vm.setCurrentPanel(levelTwo.title)
                              }
                            }
                          },
                          [
                            _vm.showIconList(levelThree)
                              ? _c("icon-list", {
                                  attrs: {
                                    items: levelThree.children,
                                    title: levelThree.title
                                  },
                                  on: { click: _vm.setCurrentPanel }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showRap(levelThree)
                              ? _c("report-problem", {
                                  attrs: {
                                    componentId: _vm.rapComponentId,
                                    config: levelThree.rapConfig,
                                    questions: _vm.rapQuestions,
                                    content: _vm.rapContent,
                                    journey: _vm.currentPanel,
                                    user: _vm.user
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showContentTemplate(levelThree)
                              ? _c("content-template", {
                                  attrs: { config: levelThree.config }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ]
                  })
                ],
                2
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c883d16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c883d16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/contact-us/_vue/ContactUs.vue
// module id = 727
// module chunks = 0